const dateFromISO = (IsoString) => {

    return IsoString.substr(8, 2) + '.' + IsoString.substr(5, 2) + '.' + IsoString.substr(0, 4);
}

export { dateFromISO }